import {useQuery} from 'react-query';
import {fetchHackerNewsTopStories} from '../api/hackerNewsApi';

export function useHackerNewsStories({enabled = false} = {}) {
    return useQuery({
        queryKey: ['hackerNewsStories'],
        queryFn: fetchHackerNewsTopStories,
        enabled,
        initialData: [],
        refetchInterval: enabled ? 5 * 60_000 : false,
        staleTime: 5 * 60_000,
    });
}

